module.exports = {"this user_name has existed.":"This username has existed.","invalid email or user_name.":"Invalid email or username."}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en/messages.json
// module id = b/Um
// module chunks = 23